/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label.mat-form-radio-label{font-size:12px;position:relative;display:block;padding-bottom:.5em}.mat-radio-group{display:flex;flex-wrap:wrap;justify-content:left;flex-flow:column;margin-top:18px;margin-bottom:15px}.mat-radio-group .mat-radio-button{margin-bottom:12px}.mat-radio-label-content{font-size:14px;padding-left:4px}"];
export { styles as styles };
